import { render } from "./travelPage.vue?vue&type=template&id=7992ac74&scoped=true"
import script from "./travelPage.vue?vue&type=script&lang=js"
export * from "./travelPage.vue?vue&type=script&lang=js"

import "./travelPage.vue?vue&type=style&index=0&id=7992ac74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7992ac74"]])

export default __exports__